import { render, staticRenderFns } from "./Azienda.vue?vue&type=template&id=e5bc9686"
import script from "./Azienda.vue?vue&type=script&lang=js"
export * from "./Azienda.vue?vue&type=script&lang=js"
import style0 from "./Azienda.vue?vue&type=style&index=0&id=e5bc9686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports